import { useProfile } from "../../../context/contextProfile";

const SecurityComponent = () => {
  const {
    oldPassword, setOldPassword,
    newPassword, setNewPassword,
    confirmPassword, setConfirmPassword,
    error, success
  } = useProfile();

  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      <div className="d-flex flex-column mb-3 col-7">
        <span>
          <div className="fw-bold mb-2">Old Password:</div>
          <input className="form-control" type="password"
            value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
        </span>
      </div>
      <div className="d-flex flex-column mb-3 col-7">
        <span>
          <div className="fw-bold mb-2">New Password:</div>
          <input className="form-control" type="password"
            value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
        </span>
      </div>
      <div className="d-flex flex-column mb-3 col-7">
        <span>
          <div className="fw-bold mb-2">Confirm Password:</div>
          <input className="form-control" type="password"
            value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
        </span>
      </div>
    </>
  )
}

export default SecurityComponent;
